// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.headers-align .mat-expansion-panel-header-description {
  justify-content: flex-end;
  align-items: center;
}

.noBck {
  background-color: transparent;
}

.form-group {
  margin-bottom: 0;
}

.modal-title {
  padding: 0 !important;
  line-height: 37px;
}

.inline-input {
  text-align: center;
  width: 44px;
  display: inline-block;
  margin: 0 7px;
  height: 20px;
  padding: 5px;
}

.inline-input:last-child {
  margin-right: 20px;
}

.glyphicon-remove {
  top: 5px;
}

.mat-button {
  background: transparent;
  padding: 0 7px;
}

.panel-default {
  width: 49%;
}

table#responsability tr td,
table#responsability tr th {
  padding-left: 7px;
  padding-right: 8px;
}

table#responsability tr td.left,
table#responsability tr th.left {
  padding-left: 15px;
}

table#responsability tr td.right,
table#responsability tr th.right {
  padding-right: 15px;
}

table#responsability tr td {
  padding-bottom: 15px;
}

table#responsability tr th.numericalData {
  text-align: center;
}

table#responsability tr td {
  vertical-align: top;
}

.scoreContainer {
  width: 50px;
  margin-right: 25px;
}

.scoreContainer h4 {
  width: 100%;
  text-align: center;
}

.scoreContainer input, input.scoreContainer {
  text-align: center;
}

.graphWrap {
  width: 80%;
  padding: 15px 0 0 0;
}

.rightCorner {
  position: absolute;
  top: 0;
  right: 10px;
}

::ng-deep .rightCorner .mat-button-wrapper span {
  text-decoration: underline;
}

/* Dropdown Content (Hidden by Default) */
.dropdown-content {
  display: none;
  position: absolute;
  background-color: white;
  min-width: 160px;
  box-shadow: 0 3px 4px 0 rgba(0, 0, 0, 0.2);
  z-index: 1;
  cursor: pointer;
  margin: 20px 5px;
}

/* Dropdown Button */
.dropbtn {
  text-align: right;
  padding: 5px 5px 0 5px;
  border: none;
  font-family: "MontserratLight", sans-serif;
}

.dropbtnSmall {
  width: 160px;
}

div.surfInPage div {
  width: 100%;
  padding: 5px;
}

div.surfInPage div:hover {
  background-color: #DDD;
}

.dropdown {
  display: inline-block;
}

::ng-deep .mat-expansion-panel-spacing {
  margin: 5px 0 !important;
}

::ng-deep .mat-expansion-panel:not([class*=mat-elevation-z]) {
  box-shadow: 0 2px 1px -2px rgba(0, 0, 0, 0.2), 0 0 1px 0 rgba(0, 0, 0, 0.14), 0 1px 3px 0 rgba(0, 0, 0, 0.12);
}`, "",{"version":3,"sources":["webpack://./src/app/jobs/components/web/jobs-edit-modal/jobs-edit-modal.component.scss"],"names":[],"mappings":"AAAA;EACI,yBAAA;EACA,mBAAA;AACJ;;AAEA;EAAS,6BAAA;AAET;;AAAA;EAAc,gBAAA;AAId;;AAFA;EACI,qBAAA;EACA,iBAAA;AAKJ;;AAFA;EACI,kBAAA;EACA,WAAA;EACA,qBAAA;EACA,aAAA;EACA,YAAA;EACA,YAAA;AAKJ;;AAFA;EACI,kBAAA;AAKJ;;AAFA;EACI,QAAA;AAKJ;;AAFA;EACI,uBAAA;EACA,cAAA;AAKJ;;AAFA;EACI,UAAA;AAKJ;;AAFA;;EAEI,iBAAA;EACA,kBAAA;AAKJ;;AAFA;;EAEI,kBAAA;AAKJ;;AAFA;;EAEI,mBAAA;AAKJ;;AAFA;EACI,oBAAA;AAKJ;;AAFA;EACI,kBAAA;AAKJ;;AAFA;EACI,mBAAA;AAKJ;;AAFA;EACI,WAAA;EACA,kBAAA;AAKJ;;AAFA;EACI,WAAA;EACA,kBAAA;AAKJ;;AAFA;EAA8C,kBAAA;AAM9C;;AAJA;EACI,UAAA;EAEA,mBAAA;AAMJ;;AAHA;EACI,kBAAA;EACA,MAAA;EACA,WAAA;AAMJ;;AAHA;EACI,0BAAA;AAMJ;;AAHA,yCAAA;AACA;EACI,aAAA;EACA,kBAAA;EACA,uBAAA;EACA,gBAAA;EACA,0CAAA;EACA,UAAA;EACA,eAAA;EACA,gBAAA;AAMJ;;AAHA,oBAAA;AACA;EACI,iBAAA;EACA,sBAAA;EACA,YAAA;EACA,0CAAA;AAMJ;;AAHA;EAAgB,YAAA;AAOhB;;AALA;EACI,WAAA;EACA,YAAA;AAQJ;;AALA;EAA2B,sBAAA;AAS3B;;AAPA;EAAY,qBAAA;AAWZ;;AATA;EAAyC,wBAAA;AAazC;;AAXA;EACI,6GAAA;AAcJ","sourcesContent":[".headers-align .mat-expansion-panel-header-description {\n    justify-content: flex-end;\n    align-items: center;\n}\n\n.noBck { background-color: transparent; }\n\n.form-group { margin-bottom: 0; }\n\n.modal-title {\n    padding: 0 !important;\n    line-height: 37px;\n}\n\n.inline-input {\n    text-align: center;\n    width: 44px;\n    display: inline-block;\n    margin: 0 7px;\n    height: 20px;\n    padding: 5px;\n}\n\n.inline-input:last-child {\n    margin-right: 20px;\n}\n\n.glyphicon-remove {\n    top: 5px;\n}\n\n.mat-button {\n    background: transparent;\n    padding: 0 7px;\n}\n\n.panel-default {\n    width: 49%;\n}\n\ntable#responsability tr td,\ntable#responsability tr th{\n    padding-left: 7px;\n    padding-right: 8px;\n}\n\ntable#responsability tr td.left,\ntable#responsability tr th.left{\n    padding-left: 15px;\n}\n\ntable#responsability tr td.right,\ntable#responsability tr th.right{\n    padding-right: 15px;\n}\n\ntable#responsability tr td {\n    padding-bottom: 15px;\n}\n\ntable#responsability tr th.numericalData {\n    text-align: center;\n}\n\ntable#responsability tr td {\n    vertical-align: top;\n}\n\n.scoreContainer {\n    width: 50px;\n    margin-right: 25px;\n}\n\n.scoreContainer h4 {\n    width: 100%;\n    text-align: center;\n}\n\n.scoreContainer input, input.scoreContainer { text-align: center; }\n\n.graphWrap {\n    width: 80%;\n    // margin: auto;\n    padding: 15px 0 0 0;\n}\n\n.rightCorner {\n    position: absolute;\n    top: 0;\n    right: 10px;\n}\n\n::ng-deep .rightCorner .mat-button-wrapper span {\n    text-decoration: underline;\n}\n\n/* Dropdown Content (Hidden by Default) */\n.dropdown-content {\n    display: none;\n    position: absolute;\n    background-color: white;\n    min-width: 160px;\n    box-shadow: 0 3px 4px 0 rgba(0,0,0,0.2);\n    z-index: 1;\n    cursor: pointer;\n    margin: 20px 5px;\n}\n\n/* Dropdown Button */\n.dropbtn {\n    text-align: right;\n    padding: 5px 5px 0 5px;\n    border: none;\n    font-family: 'MontserratLight',  sans-serif;\n}\n\n.dropbtnSmall { width: 160px; }\n\ndiv.surfInPage div {\n    width: 100%;\n    padding: 5px;\n}\n\ndiv.surfInPage div:hover { background-color: #DDD;}\n\n.dropdown { display: inline-block; }\n\n::ng-deep .mat-expansion-panel-spacing { margin: 5px 0 !important; }\n\n::ng-deep .mat-expansion-panel:not([class*=mat-elevation-z]) {\n    box-shadow: 0 2px 1px -2px rgb(0 0 0 / 20%), 0 0 1px 0 rgb(0 0 0 / 14%), 0 1px 3px 0 rgb(0 0 0 / 12%);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
